/**
 * Custom component that hold the add ons section before goign to checkout
 *
 * @class PreCheckout
 * @typedef {PreCheckout}
 * @extends {HTMLElement}
 */
class PreCheckout extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll(".add-ons-closer").forEach((el) => {
      el.addEventListener("click", () => {
        this.close();
        const returnToDefault = document.querySelector(
          "#return-to-mob-default",
        );
        const mealPlanCalculator = document.querySelector(
          "meal-plan-calculator",
        );
        const paymentOptions = document.querySelector(".payment-options");
        const mobNextStep = document.querySelector("#mob-next-step");
        const mobileItemsViewerTrigger = document.querySelector(
          "#mobile-items-viewer-trigger",
        );

        // mobile flow reset
        returnToDefault?.classList.add("visually-hidden");
        mealPlanCalculator?.classList.remove("visually-hidden");
        paymentOptions?.classList.remove("opened");
        mobNextStep?.classList.remove("gone");
        mobileItemsViewerTrigger?.classList.remove("no-events");
      });
    });
  }

  close() {
    document.querySelector("body").classList.remove("locked");
    document.querySelector(".add-ons").classList.add("closed");
  }
}

customElements.define("pre-checkout", PreCheckout);
